"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const queryFieldKeyToDataType_1 = __importDefault(require("@opsbase/lib-data-queryfield/helpers/queryFieldKeyToDataType"));
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
function FiltersList() {
    const dt = (0, useDataTree_1.default)();
    const { filters, highlightedGroups, highlightedDateRange } = (0, useView_1.default)(dt.viewId);
    const { removeFilter, toggleHighlightedGroup, toggleHighlightedDateRange } = (0, useViewActions_1.default)(dt.viewId);
    const handleDeleteFilter = (0, useCallforward_1.default)((filter) => () => {
        removeFilter(filter);
    }, [removeFilter]);
    const handleDeleteHighlightedGroup = (0, useCallforward_1.default)((group) => () => {
        toggleHighlightedGroup(group);
    }, [toggleHighlightedGroup]);
    const handleDeleteHighlightedDateRange = (0, react_1.useCallback)(() => {
        toggleHighlightedDateRange(undefined);
    }, [toggleHighlightedDateRange]);
    const highlightedDateRangePill = (0, react_1.useMemo)(() => {
        if (!highlightedDateRange)
            return null;
        const queryField = QueryFieldRegistry_1.default[highlightedDateRange.key];
        const label = (0, getFromStringOrFunction_1.getFromStringOrFunction)(queryField.label);
        const value = (0, moment_timezone_1.default)(highlightedDateRange.from).format('DD MMM') +
            ' - ' +
            (0, moment_timezone_1.default)(highlightedDateRange.to).format('DD MMM');
        return (react_1.default.createElement(DataPill_1.default, { style: { marginLeft: 4 }, type: (0, queryFieldKeyToDataType_1.default)(highlightedDateRange.key), label: label, value: value, onDelete: handleDeleteHighlightedDateRange }));
    }, [handleDeleteHighlightedDateRange, highlightedDateRange]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        filters
            .filter(fb => !fb.hidden)
            .map((fb, i) => {
            const queryField = QueryFieldRegistry_1.default[fb.queryFieldKey];
            const label = (0, getFromStringOrFunction_1.getFromStringOrFunction)(queryField.label);
            if (!!highlightedGroups
                .filter(g => !!g.queryFieldKey)
                .find(group => group.queryFieldKey === fb.queryFieldKey))
                return null;
            return (react_1.default.createElement(DataPill_1.default, { style: { marginLeft: 4 }, key: 'filter' + i, type: (0, queryFieldKeyToDataType_1.default)(queryField.key), color: fb.color, label: label, value: fb.title, onDelete: handleDeleteFilter(fb) }));
        }),
        highlightedGroups
            .filter(g => !!g.queryFieldKey)
            .map((group, i) => {
            const queryField = QueryFieldRegistry_1.default[group.queryFieldKey];
            const label = (0, getFromStringOrFunction_1.getFromStringOrFunction)(queryField.label);
            return (react_1.default.createElement(DataPill_1.default, { style: { marginLeft: 4 }, key: 'highlight' + i, type: (0, queryFieldKeyToDataType_1.default)(queryField.key), color: group.color, label: label, value: group.title, onDelete: handleDeleteHighlightedGroup(group) }));
        }),
        highlightedDateRangePill));
}
exports.default = FiltersList;
